/**
 * @fileoverview gRPC-Web generated client stub for featureflag
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: featureflag/featureflag.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var account_account_pb = require('../account/account_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.featureflag = require('./featureflag_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.featureflag.FeatureFlagServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.featureflag.FeatureFlagServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.featureflag.ListFeatureFlagOverridesRequest,
 *   !proto.featureflag.ListFeatureFlagOverridesResponse>}
 */
const methodDescriptor_FeatureFlagService_ListFeatureFlagOverrides = new grpc.web.MethodDescriptor(
  '/featureflag.FeatureFlagService/ListFeatureFlagOverrides',
  grpc.web.MethodType.UNARY,
  proto.featureflag.ListFeatureFlagOverridesRequest,
  proto.featureflag.ListFeatureFlagOverridesResponse,
  /**
   * @param {!proto.featureflag.ListFeatureFlagOverridesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.featureflag.ListFeatureFlagOverridesResponse.deserializeBinary
);


/**
 * @param {!proto.featureflag.ListFeatureFlagOverridesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.featureflag.ListFeatureFlagOverridesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.featureflag.ListFeatureFlagOverridesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.featureflag.FeatureFlagServiceClient.prototype.listFeatureFlagOverrides =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/featureflag.FeatureFlagService/ListFeatureFlagOverrides',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagService_ListFeatureFlagOverrides,
      callback);
};


/**
 * @param {!proto.featureflag.ListFeatureFlagOverridesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.featureflag.ListFeatureFlagOverridesResponse>}
 *     Promise that resolves to the response
 */
proto.featureflag.FeatureFlagServicePromiseClient.prototype.listFeatureFlagOverrides =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/featureflag.FeatureFlagService/ListFeatureFlagOverrides',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagService_ListFeatureFlagOverrides);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.featureflag.SetFeatureFlagOverrideRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_FeatureFlagService_SetFeatureFlagOverride = new grpc.web.MethodDescriptor(
  '/featureflag.FeatureFlagService/SetFeatureFlagOverride',
  grpc.web.MethodType.UNARY,
  proto.featureflag.SetFeatureFlagOverrideRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.featureflag.SetFeatureFlagOverrideRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.featureflag.SetFeatureFlagOverrideRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.featureflag.FeatureFlagServiceClient.prototype.setFeatureFlagOverride =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/featureflag.FeatureFlagService/SetFeatureFlagOverride',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagService_SetFeatureFlagOverride,
      callback);
};


/**
 * @param {!proto.featureflag.SetFeatureFlagOverrideRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.featureflag.FeatureFlagServicePromiseClient.prototype.setFeatureFlagOverride =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/featureflag.FeatureFlagService/SetFeatureFlagOverride',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagService_SetFeatureFlagOverride);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.featureflag.DeleteFeatureFlagOverrideRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_FeatureFlagService_DeleteFeatureFlagOverride = new grpc.web.MethodDescriptor(
  '/featureflag.FeatureFlagService/DeleteFeatureFlagOverride',
  grpc.web.MethodType.UNARY,
  proto.featureflag.DeleteFeatureFlagOverrideRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.featureflag.DeleteFeatureFlagOverrideRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.featureflag.DeleteFeatureFlagOverrideRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.featureflag.FeatureFlagServiceClient.prototype.deleteFeatureFlagOverride =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/featureflag.FeatureFlagService/DeleteFeatureFlagOverride',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagService_DeleteFeatureFlagOverride,
      callback);
};


/**
 * @param {!proto.featureflag.DeleteFeatureFlagOverrideRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.featureflag.FeatureFlagServicePromiseClient.prototype.deleteFeatureFlagOverride =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/featureflag.FeatureFlagService/DeleteFeatureFlagOverride',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagService_DeleteFeatureFlagOverride);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.featureflag.ListFeatureAccessRequest,
 *   !proto.featureflag.ListFeatureAccessResponse>}
 */
const methodDescriptor_FeatureFlagService_ListFeatureAccess = new grpc.web.MethodDescriptor(
  '/featureflag.FeatureFlagService/ListFeatureAccess',
  grpc.web.MethodType.UNARY,
  proto.featureflag.ListFeatureAccessRequest,
  proto.featureflag.ListFeatureAccessResponse,
  /**
   * @param {!proto.featureflag.ListFeatureAccessRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.featureflag.ListFeatureAccessResponse.deserializeBinary
);


/**
 * @param {!proto.featureflag.ListFeatureAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.featureflag.ListFeatureAccessResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.featureflag.ListFeatureAccessResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.featureflag.FeatureFlagServiceClient.prototype.listFeatureAccess =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/featureflag.FeatureFlagService/ListFeatureAccess',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagService_ListFeatureAccess,
      callback);
};


/**
 * @param {!proto.featureflag.ListFeatureAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.featureflag.ListFeatureAccessResponse>}
 *     Promise that resolves to the response
 */
proto.featureflag.FeatureFlagServicePromiseClient.prototype.listFeatureAccess =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/featureflag.FeatureFlagService/ListFeatureAccess',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagService_ListFeatureAccess);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.featureflag.GrantFeatureAccessRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_FeatureFlagService_GrantFeatureAccess = new grpc.web.MethodDescriptor(
  '/featureflag.FeatureFlagService/GrantFeatureAccess',
  grpc.web.MethodType.UNARY,
  proto.featureflag.GrantFeatureAccessRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.featureflag.GrantFeatureAccessRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.featureflag.GrantFeatureAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.featureflag.FeatureFlagServiceClient.prototype.grantFeatureAccess =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/featureflag.FeatureFlagService/GrantFeatureAccess',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagService_GrantFeatureAccess,
      callback);
};


/**
 * @param {!proto.featureflag.GrantFeatureAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.featureflag.FeatureFlagServicePromiseClient.prototype.grantFeatureAccess =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/featureflag.FeatureFlagService/GrantFeatureAccess',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagService_GrantFeatureAccess);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.featureflag.RevokeFeatureAccessRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_FeatureFlagService_RevokeFeatureAccess = new grpc.web.MethodDescriptor(
  '/featureflag.FeatureFlagService/RevokeFeatureAccess',
  grpc.web.MethodType.UNARY,
  proto.featureflag.RevokeFeatureAccessRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.featureflag.RevokeFeatureAccessRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.featureflag.RevokeFeatureAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.featureflag.FeatureFlagServiceClient.prototype.revokeFeatureAccess =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/featureflag.FeatureFlagService/RevokeFeatureAccess',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagService_RevokeFeatureAccess,
      callback);
};


/**
 * @param {!proto.featureflag.RevokeFeatureAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.featureflag.FeatureFlagServicePromiseClient.prototype.revokeFeatureAccess =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/featureflag.FeatureFlagService/RevokeFeatureAccess',
      request,
      metadata || {},
      methodDescriptor_FeatureFlagService_RevokeFeatureAccess);
};


module.exports = proto.featureflag;

